<template>
  <div class="user-bar">
    <div class="user-bar-wrapper" @click="toggleDropdown">
      <div class="user-bar-welcome hidden-sm-and-down">Hi, </div>
      <template v-if="params.client_name">
        <div class="user-bar-username hidden-sm-and-down">{{ params.client_name }}</div>
        <div class="user-bar-badge text-uppercase">{{ params.client_name.charAt(0) }}</div>
      </template>
    </div>
    <div class="user-dropdown-menu" :class="{'show' : showDropdown, 'hide' : !showDropdown}" ref="menu">
      <ul @click="closeUserDropdown()">
        <li><router-link to="/profile-change-auth"><v-icon>icon-user</v-icon>Profile Setting</router-link></li>
        <span class="separator"></span>
        <li><a v-if="userIsLogged" @click="authLogout"><v-icon>icon-logout</v-icon>Logout</a></li>
      </ul>
    </div>
    <div class="user-overlay" @click="closeUserDropdown" v-if="showDropdown"></div>
  </div>
</template>

<script>
export default {
  name: 'User',
  props: {
    userIsLogged: {
      type: [String, Number],
      default: '0'
    },
    params: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    showDropdown: false,
    timer: 1
  }),
  methods: {
    authLogout () {
      this.$store.dispatch('auth/authLogout')
    },
    toggleDropdown () {
      if (this.showDropdown === false) {
        this.showDropdown = true
      } else {
        this.closeUserDropdown()
      }
    },
    closeUserDropdown () {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      // this.$refs.menu.classList.add('hide-anim')
      this.timer = setTimeout(() => {
        this.showDropdown = false
      }, 150)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/header/User.vue